/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Button, Divider, Tooltip, Typography } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import ApartmentIcon from "@mui/icons-material/Apartment";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ROUTE_PATH } from "../../constants/route";
import { getTrip } from "../../store/reducers/home/apiThunk";
import StyledPaymentSuccess from "./StyledPaymentSuccess";
import { toTwoDecimalPlaces } from "../../utils/commonFuntions";
import moment from "moment";

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tripDetails, setTripDetails] = useState([]);

  useEffect(() => {
    const getTripDetails = () => {
      dispatch(getTrip()).then((result) => {
        setTripDetails(result?.payload?.data)
      })
    }
    getTripDetails()
  }, [])

  const orderData = sessionStorage.getItem("orderData") || null;


  function formatDateToLongForm(dateStr) {
    return moment(dateStr, 'YYYY-MM-DD').format('D MMMM YYYY');
  }

  const bagItems = JSON.parse(orderData)
  const totalPrice = bagItems?.length > 0 ? bagItems.reduce((sum, item) => sum + parseFloat(item.price * item.quantity), 0) : "0";
  const calculatePercentage = (percentage, total) => {
    return (percentage / 100) * total;
  };
  return (
    <StyledPaymentSuccess>
      <Box className='payment-success-wrap'>
        <Box className='payment-success-box'>
          <Box className='payment-success-icon-wrap'>
            <DoneIcon sx={{ fontSize: "33px", color: "white" }} />
          </Box>
        </Box>
        <Box className='payment-success-text-wrap'>
          <Typography className='payment-success-text-header'>
            Order Confirmed!
          </Typography>
          <Typography className='payment-success-text-body'>
            Your order has been successfully placed. You can check this order as
            a trip in your Planned Trip Closet.
          </Typography>
        </Box>
        <Box className='trip-deatails'>
          <Typography className='trip-title'>Trip details</Typography>
          <Box className='info-container-2'>
            <Box className='info-container'>
              <ApartmentIcon className='icon-person-1' sx={{ color: "#A78D78" }} />
              <Typography className='bold-text-1'>{tripDetails?.[0]?.hotel_name}</Typography>
            </Box>
            <Typography className='location-text'>{tripDetails?.[0]?.city_name}</Typography>
            <Box>
              <Typography className='arrival-text'>
                <Typography className='arrival-text-1'>Arrival date</Typography>
                <Typography className='arrival-bold-span'>{formatDateToLongForm(tripDetails?.[0]?.arrival_date)}</Typography>
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className='payment-summary-wrap'>
          <Box className='payment-summary'>
            <Typography className='payment-summary-header'>
              Amount Summary
            </Typography>
            <Box className="amount-container">
              <Typography className="amount-text">Reservation fee</Typography>
              <Typography className="amount">{bagItems?.[0]?.service_fees ? `$${toTwoDecimalPlaces(bagItems?.[0]?.service_fees)}` : "--"}</Typography>
            </Box>
            {bagItems?.[0].payment_component?.length > 0
              ? bagItems?.[0].payment_component.map((element) => {
                return (
                  <Box className="amount-container">
                    <Typography className="amount-text">{element?.payment_component_name}</Typography>
                    <Typography className="amount">{`$${toTwoDecimalPlaces(element?.component_type === "percentage" ? calculatePercentage(element?.component_value, bagItems?.[0]?.price)  : element?.component_value)}`}</Typography>
                  </Box>
                );
              })
              : null}
            <Box className="amount-container">
              <Typography className="amount-text">
                Subtotal
                <Tooltip
                  title='Payable amount for kept items after trial.'
                  arrow
                  placement='right'
                >
                  <InfoOutlinedIcon fontSize='small' className='infoIcon' />
                </Tooltip>
              </Typography>
              <Typography className="amount">{totalPrice ? `$${toTwoDecimalPlaces(totalPrice)}` : "--"}</Typography>
            </Box>
            <Divider />
            <Box className="amount-container">
              <Typography className="total-amount-text">Total Amount Paid</Typography>
              <Typography className="total-amount">{bagItems?.[0]?.service_fees ? `$${toTwoDecimalPlaces(bagItems?.[0]?.service_fees)}` : "--"}</Typography>
            </Box>
          </Box>
        </Box>
        <Box className='button-wrap'>
          <Button className='continue-shopping-btn' onClick={() => navigate(ROUTE_PATH.HOME)}>Continue shopping</Button>
          <Link to={`${ROUTE_PATH.CLOSET}?tab=Planned`} className="view-planned-trip-btn">View planned trip</Link>
        </Box>
      </Box>
    </StyledPaymentSuccess>
  );
};

export default PaymentSuccessPage;
